import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

const FairHousingPolicy = () => {
  document.title = "Fair Housing & Anti-Discrimination Policy | Porcher";

  return (
    <div className="page-content">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="border-0 shadow-sm mt-4">
              <CardBody className="p-4">
                <h1 className="mb-3">Fair Housing &amp; Anti-Discrimination Policy</h1>
                <p className="text-muted small mb-4">Last updated: August 22, 2026</p>

                <div className="content">
                  <h5 className="mt-4">1. Our Commitment</h5>
                  <p>
                    Patronage Reservoir LLC, a Nevada limited liability company doing business as Porcher ("Porcher",
                    "we", "our", or "us"), is committed to equal housing opportunity. We do not tolerate discrimination
                    on the Platform, and we require every Homeowner using Porcher to list, screen, and select tenants
                    in a manner that complies with the federal Fair Housing Act and all applicable state and local
                    fair housing laws.
                  </p>

                  <h5 className="mt-4">2. Protected Classes</h5>
                  <p>
                    The federal Fair Housing Act prohibits discrimination based on race, color, religion, sex
                    (including sexual orientation and gender identity), national origin, familial status, and
                    disability. Many states and cities protect additional characteristics — which may include source
                    of income, marital status, age, sexual orientation or gender identity where not already covered
                    federally, and military or veteran status, among others. Homeowners are responsible for knowing
                    and complying with every protected class that applies to their property's location, not just the
                    federal list above.
                  </p>

                  <h5 className="mt-4">3. Prohibited Conduct</h5>
                  <p>On the Platform, you may not, on the basis of a protected class:</p>
                  <ul>
                    <li>Refuse to rent, show, or negotiate with an Applicant or Tenant</li>
                    <li>Advertise a listing in a way that states or implies a preference, limitation, or exclusion</li>
                    <li>Apply different screening criteria, rental terms, fees, or conditions to different Applicants</li>
                    <li>Make discriminatory statements in a listing, application review, or in-app message</li>
                    <li>Retaliate against someone for asserting their fair housing rights</li>
                  </ul>

                  <h5 className="mt-4">4. Listings &amp; Advertising Standards</h5>
                  <p>
                    Listings created on the Platform must reflect equal housing opportunity — describe the property,
                    not a preferred type of tenant. Language that expresses a preference, limitation, or exclusion
                    based on a protected class is not permitted in a listing, photo, or description.
                  </p>

                  <h5 className="mt-4">5. Consistent Screening Criteria</h5>
                  <p>
                    Whatever screening criteria a Homeowner chooses for a listing (for example, minimum income, credit
                    thresholds, or criminal/eviction history standards), those criteria must be applied the same way
                    to every Applicant for that listing. See our{" "}
                    <Link to="/tenant-screening-policy">Tenant Screening &amp; FCRA Policy</Link> for how screening
                    results should be used.
                  </p>

                  <h5 className="mt-4">6. Reasonable Accommodations &amp; Modifications</h5>
                  <p>
                    Applicants and Tenants with disabilities may request reasonable accommodations to rules, policies,
                    or practices, or reasonable modifications to the property, where necessary to have an equal
                    opportunity to use and enjoy the home. Homeowners are expected to engage in good faith with such
                    requests, consistent with applicable law.
                  </p>

                  <h5 className="mt-4">7. Porcher's Role</h5>
                  <p>
                    Porcher provides the software Homeowners use to list, screen, and communicate with Applicants and
                    Tenants — we are not a party to the rental relationship and do not make tenant-selection
                    decisions. Each Homeowner is independently responsible for complying with the Fair Housing Act and
                    applicable state and local fair housing laws. Porcher may remove listings or content, and may
                    suspend or terminate accounts, that appear to violate this policy.
                  </p>

                  <h5 className="mt-4">8. Reporting a Concern</h5>
                  <p>
                    If you believe a listing, message, or screening practice on the Platform violates fair housing
                    law or this policy, please report it through the support portal so we can review it.
                  </p>

                  <h5 className="mt-4">9. Consequences of Violations</h5>
                  <p>
                    Violations of this policy may result in content removal, warnings, suspension, or termination of
                    an account, and — where required by law — a report to the appropriate government agency.
                  </p>

                  <h5 className="mt-4">10. Resources</h5>
                  <p>
                    If you believe you have experienced housing discrimination, you can contact the U.S. Department
                    of Housing and Urban Development or your state or local fair housing agency for guidance on filing
                    a complaint.
                  </p>

                  <h5 className="mt-4">11. Contact Us</h5>
                  <p>
                    If you have questions about this Fair Housing &amp; Anti-Discrimination Policy, please contact us
                    through the support portal.
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FairHousingPolicy;
